// pipeCatalog.js — дефолтный список круглых и квадратных труб с ценой за метр

/** Наружный ⌀ трубы Ду25 / 1" (мм). */
const DN25_PIPE_OD_MM = 33.7;

/**
 * В DEFAULT_PIPE_COMBOS для ⌀33,7 заведена одна позиция — её используем для прайса и логики толщин
 * независимо от того, как в модели указаны покрытие/толщина.
 */
export function getDn25CatalogPipeSpec() {
  return { diameter: DN25_PIPE_OD_MM, thickness: 'x3', coating: 'Зеркало' };
}

export function isDn25PipeDiameter(outerDiameterMm) {
  const d = Number(outerDiameterMm);
  return Number.isFinite(d) && Math.abs(d - DN25_PIPE_OD_MM) < 0.01;
}

// Круглые трубы: ключ формата 'диаметр|толщина|покрытие'
export const DEFAULT_PIPE_COMBOS = {
  '10|x1|Матовый': 110,
  '13.7|x2|Матовый': 300,
  '17.2|x2|Матовый': 350,
  '18|x2|Зеркало': 359,
  '21.3|x2|Матовый': 405,
  '21.3|x3|Матовый': 585,
  '22|x1.5|Матовый': 335,
  '25|x3|Матовый': 710,
  '26.9|x2|Матовый': 550,
  '26.9|x3|Матовый': 810,
  '28|x1.5|Матовый': 465,
  '32|x2|Матовый': 550,
  '32|x3|Зеркало': 1150,
  '33.7|x3|Зеркало': 1290,
  '35|x1.5|Матовый': 610,
  '38|x2|Матовый': 700,
  '42.4|x2|Матовый': 855,
  '42.4|x2|Зеркало': 930,
  '42.4|x3|Матовый': 1270,
  '48.3|x2|Матовый': 950,
  '48.3|x3|Матовый': 1460,
  '54|x2|Матовый': 1100,
  '60.3|x2|Матовый': 1210,
  '60.3|x2|Зеркало': 1090,
  '60.3|x3|Матовый': 1900,
  '76.1|x2|Матовый': 1570,
  '76.1|x3|Матовый': 2340,
  '88.9|x2|Матовый': 1650,
  '88.9|x2|Зеркало': 1530,
  '88.9|x3|Матовый': 2850,
  '101.6|x2|Зеркало': 2215,
  '114.3|x2|Матовый': 2680,
  '114.3|x3|Матовый': 3790,
  '129|x2|Матовый': 3000,
  '129|x3|Матовый': 6000,
  '139.7|x2|Матовый': 3180,
  '139.7|x3|Матовый': 4715,
  '159|x2|Матовый': 3530,
  '159|x3|Матовый': 5530,
  '168.3|x3|Матовый': 5950,
  '219.1|x3|Матовый': 8100,
  '273|x3|Матовый': 10300,
  '306|x3|Матовый': 13175,
  '323.9|x3|Матовый': 18100,
  '355.6|x3|Матовый': 19500,
  '406.4|x3|Матовый': 25000,
  '508|x3|Матовый': 27000,
  '508|x4|Матовый': 37200,
  '609.6|x3|Матовый': 28345,
  '609.6|x4|Матовый': 38150,
};

// Квадратные трубы (профиль): ключ формата 'SQUARE_PROFILE|профиль|толщина|покрытие'
export const DEFAULT_SQUARE_PIPE_COMBOS = {
  'SQUARE_PROFILE|20x20|1.5|Матовый': 310,
  'SQUARE_PROFILE|25x25|2|Матовый': 530,
  'SQUARE_PROFILE|40x40|2|Матовый': 1100,
  'SQUARE_PROFILE|50x50|2|Матовый': 1300,
  'SQUARE_PROFILE|60x30|2|Матовый': 1210,
  'SQUARE_PROFILE|60x60|2|Матовый': 1630,
  'SQUARE_PROFILE|80x40|2|Матовый': 1610,
  'SQUARE_PROFILE|80x80|2|Матовый': 1900,
  'SQUARE_PROFILE|100x100|3|Матовый': 3900,
  'SQUARE_PROFILE|150x150|3|Матовый': 4500,
};

// Квадратные трубы (лист): ключ формата 'SQUARE_SHEET|лист|толщина|покрытие'
// Значение - объект { pricePerMeter: цена_за_метр, coefficient1: коэффициент1, coefficient2: коэффициент2 }
// Формула: pricePerMeter * (длина_в_метрах) * (coefficient1 + coefficient2 / L), где L - длина в миллиметрах
export const DEFAULT_SQUARE_SHEET_COMBOS = {
  'SQUARE_SHEET|60x30|2|Матовый': { pricePerMeter: 615, coefficient1: 1.28, coefficient2: 26.4 },
  'SQUARE_SHEET|80x40|2|Матовый': { pricePerMeter: 840, coefficient1: 1.206, coefficient2: 28.5 },
};

// Маппинг профиля на приближенный размер для отображения
export const SQUARE_PROFILE_DISPLAY_SIZE = {
  '20x20': 20,
  '25x25': 25,
  '40x40': 40,
  '50x50': 50,
  '60x30': 30,
  '60x60': 60,
  '80x40': 40,
  '80x80': 80,
  '100x100': 100,
  '150x150': 150,
};

// Маппинг листа на приближенный размер для отображения
export const SQUARE_SHEET_DISPLAY_SIZE = {
  '60x30': 30,
  '80x40': 40,
};

